const process = {
  PROCESS: 'PROCESS',
  PROCESSES: 'PROCESSES',
};

export { process };
